var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMusicPlayerPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.748 16.067L21.3477 22.6667L23.4915 20.5228L19.0385 16.0698L23.5479 11.5604L21.4041 9.41655L16.8946 13.926L16.8918 13.9232L14.748 16.067Z",
    fill: "#212624",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9.33339,
    width: 13.3333,
    height: 3.03184,
    transform: "rotate(90 12 9.33339)",
    fill: "#212624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusicPlayerPrev);
export default __webpack_public_path__ + "static/media/icon_music_player_prev.b9ba8f946067036460c59fb666386c65.svg";
export { ForwardRef as ReactComponent };